import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import BottomNav from "../../components/BottomNav.tsx";
import { Plus } from "lucide-react";
import { baseurly } from "../../utils/apis.ts";
import { X_API_KEY } from "../../utils/apis.ts";
import { digitalOceanImageUrl } from "../../utils/digitalOcean.ts";

interface Building {
  id: number;
  building_name: string;
}

const SelectBuildingPage: React.FC = () => {
  const navigate = useNavigate();
  const [buildings, setBuildings] = useState<Building[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch(`${baseurly}/buildings`, {
                   
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': X_API_KEY,
          },
          credentials: "include",
        })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch buildings");
        return res.json();
      })
      .then((data) => {
        setBuildings(data);
        setLoading(false);
        console.log(data);
      })
      .catch((err) => {
        console.error("Error fetching buildings:", err);
        setError("Unable to load buildings");
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen w-full bg-blue-900 pb-20">
      {/* Header */}
      <div className="p-4 flex justify-between items-center">
        <img
          src={digitalOceanImageUrl("new%20logos/Asset%204.png")}
          alt="KMC Logo"
          className="w-16 h-auto"
        />
      </div>

      <h1 className="text-2xl text-white font-bold text-center p-3">Select a Building</h1>

      {/* Building List */}
      <div className="bg-white  rounded-3xl">
      <div className=" mb-6 bg-white rounded-full p-6">
      <div className="bg-white rounded-xl border p-8 flex justify-between items-center">
          <div>
            <h2 className="text-blue-900 text-xl font-bold mb-2">List of Buildings</h2>
            <p className="text-gray-600 text-sm max-w-xs">
              Find clear, step-by-step instructions to help you complete your tasks efficiently and accurately.
            </p>
          </div>
          <img src={digitalOceanImageUrl("assets/images/machineimage.jpg")} alt="12M EVS" className="w-27 h-24" />
        </div>
      </div>
        <div className="space-y-4 p-4">
          {loading ? (
            <p className="text-white">Loading buildings...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : (
            <div className="grid grid-cols-1 gap-2">
              {buildings.map((building) => (
                <div
                  key={building.id}
                  onClick={() => navigate(`/assign-workstations/${building.id}`)}
                  className="w-full  text-lg font-semibold mb-4 bg-sky-200 p-4 rounded-lg shadow-md hover:bg-blue-100"
                >
                  {building.building_name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Bottom Navigation */}
      <BottomNav showBack={true} />
    </div>
  );
};

export default SelectBuildingPage;
